import { useLanguage } from "@/contexts/LanguageContext";
import productDemoGif from "@/assets/product-demo.gif";

const ProductDemoSection = () => {
  const { t, language } = useLanguage();
  const isThai = language === "th";

  return (
    <section className="pt-0 pb-4 lg:pb-6 px-4 sm:px-6 relative overflow-hidden bg-transparent">

      <div className="container mx-auto max-w-7xl relative z-10">
        <div className="text-center mb-4 mt-6 px-2">
          <h2 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold text-foreground">
            {t("productDemo.title") !== "productDemo.title" 
              ? t("productDemo.title") 
              : "See the Platform in Action"}
          </h2>
          <p className="text-sm sm:text-base md:text-lg text-muted-foreground max-w-2xl mx-auto mt-3 sm:mt-4">
            {t("productDemo.subtitle") !== "productDemo.subtitle" 
              ? t("productDemo.subtitle") 
              : "Experience how Carbonwize simplifies carbon data collection and reporting"}
          </p>
        </div>

          <div className="max-w-7xl mx-auto">
          <div className="relative overflow-visible">
            <img
              src={productDemoGif}
              alt={isThai ? "สาธิตแพลตฟอร์ม Carbonwize - ระบบรวบรวมและรายงานข้อมูลคาร์บอนอัตโนมัติสำหรับองค์กร" : "Carbonwize platform demonstration - Automated carbon data collection and reporting system for enterprises"}
              className="w-full h-auto -my-4 sm:-my-8 md:-my-12 lg:-my-16"
              loading="lazy"
              width={1920}
              height={1080}
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default ProductDemoSection;
